<template>
  <v-form v-model="valid" ref="mainForm">
    <v-checkbox
      class="list_counter_validator my-2 ml-6 p-0"
      :input-value="hasOneFieldCompleted"
      :rules="[(v) => !!v || 'Veuillez remplir au moins une information.']"
    ></v-checkbox>

    <opq-text-field code="pi_nom" v-model="sasSignalementPi.nomSignalee" :live="liveSasSignalementPi(16511)" optional></opq-text-field>

    <opq-text-field code="pi_prenom" v-model="sasSignalementPi.prenomSignalee" :live="liveSasSignalementPi(16510)" optional></opq-text-field>

    <opq-text-field
      code="pi_nomorganisation"
      v-model="sasSignalementPi.nomOrganisationSignalee"
      :live="liveSasSignalementPi(16512)"
      optional
    ></opq-text-field>

    <opq-text-field
      code="pi_adressesignalee"
      v-model="sasSignalementPi.adressePersonneSignalee"
      :live="liveSasSignalementPi(16513)"
      :id="'adresseSignalee'"
      ref="adresseSignalee"
      optional
    ></opq-text-field>

    <opq-text-field
      code="pi_complementadressesignalee"
      v-model="sasSignalementPi.complementDAdresseSignalee"
      :live="liveSasSignalementPi(16525)"
      ref="complementDAdresseSignalee"
      optional
    ></opq-text-field>

    <opq-text-field
      code="pi_cpsignalee"
      v-model="sasSignalementPi.codePostalSignalee"
      :live="liveSasSignalementPi(16526)"
      is-code-postal
      :code-pays="codePays(sasSignalementPi.paysSignalee)"
      ref="codePostalSignalee"
      optional
    ></opq-text-field>

    <opq-text-field
      code="pi_villesignalee"
      v-model="sasSignalementPi.villeSignalee"
      :live="liveSasSignalementPi(16527)"
      ref="villeSignalee"
      optional
    ></opq-text-field>

    <opq-catalogue
      code="pi_provincesignalee"
      v-model="sasSignalementPi.provinceSignalee"
      :live="liveSasSignalementPi(16528)"
      :opq-if="paysEstUSouCA(sasSignalementPi.paysSignalee)"
      :parent="sasSignalementPi.paysSignalee"
      order-by="text"
      ref="provinceSignalee"
      optional
    ></opq-catalogue>

    <opq-catalogue
      code="pi_payssignalee"
      v-model="sasSignalementPi.paysSignalee"
      :live="liveSasSignalementPi(16529)"
      ref="paysSignalee"
      order-by="text"
      optional
    ></opq-catalogue>

    <opq-text-field
      code="pi_telephonesignalee"
      v-model="sasSignalementPi.telephoneSignalee"
      :live="liveSasSignalementPi(16514)"
      is-phone-number
      :code-pays="codePays(sasSignalementPi.paysSignalee)"
      optional
    ></opq-text-field>

    <opq-text-field
      code="pi_courrielsignalee"
      v-model="sasSignalementPi.courrielSignalee"
      :live="liveSasSignalementPi(16515)"
      is-email
      optional
    ></opq-text-field>

    <opq-text-field code="pi_siteinternet" v-model="sasSignalementPi.siteWebSignalee" :live="liveSasSignalementPi(16516)" optional></opq-text-field>

    <opq-text-field
      code="pi_autresiteinternet"
      v-model="sasSignalementPi.autresSitesWeb"
      :live="liveSasSignalementPi(16517)"
      optional
    ></opq-text-field>

    <opq-text-field
      code="pi_nomemployeursignale"
      v-model="sasSignalementPi.nomEmployeur"
      :live="liveSasSignalementPi(16508)"
      optional
    ></opq-text-field>

    <opq-catalogue
      code="pi_activitesreservees"
      v-model="sasSignalementPi.activitesReserveesOuTitresUsurpes"
      :live="liveSasSignalementPi(16509)"
      multiple
      optional
    ></opq-catalogue>

    <opq-memo code="pi_objet" v-model="sasSignalementPi.commentaires" :live="liveSasSignalementPi(16505)" optional></opq-memo>

    <opq-catalogue code="pi_preuvepi" v-model="sasSignalementPi.preuvePratiqueIllegale" :live="liveSasSignalementPi(16506)"></opq-catalogue>

    <opq-file-multiple
      :opq-if="ADesPreuves"
      code="pi_preuvepidocument"
      :files="sasSignalementPi.preuves"
      :live="liveSasSignalementPi(16507)"
    ></opq-file-multiple>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import PosteCanada from "@/mixins/PosteCanada"

export default {
  mixins: [FormSimple, CataloguesHelper, PosteCanada],
  props: {
    sas: { type: Object }
  },

  data: () => ({
    posteCanadaMainconfig: {
      searchFieldId: "adresseSignalee",
      adresseKey: "adresseSignalee",
      completementDAdresseKey: "complementDAdresseSignalee",
      villeKey: "villeSignalee",
      codePostalKey: "codePostalSignalee",
      provinceKey: "provinceSignalee",
      paysKey: "paysSignalee"
    }
  }),

  computed: {
    sasSignalementPi() {
      return this.sas.sasSignalementPratiqueIllegale
    },

    ADesPreuves() {
      return this.estOui(this.sasSignalementPi.preuvePratiqueIllegale)
    },

    hasOneFieldCompleted() {
      return (
        this.sasSignalementPi.nomSignalee ||
        this.sasSignalementPi.prenomSignalee ||
        this.sasSignalementPi.nomOrganisationSignalee ||
        this.sasSignalementPi.adressePersonneSignalee ||
        this.sasSignalementPi.complementDAdresseSignalee ||
        this.sasSignalementPi.codePostalSignalee ||
        this.sasSignalementPi.villeSignalee ||
        this.sasSignalementPi.telephoneSignalee ||
        this.sasSignalementPi.siteWebSignalee ||
        this.sasSignalementPi.nomEmployeur ||
        this.sasSignalementPi.activitesReserveesOuTitresUsurpes.length > 0 ||
        this.sasSignalementPi.commentaires
      )
    }
  },

  methods: {
    liveSasSignalementPi(cle) {
      return { endpoint: "/sas-signalement-pratique-illegale/", cle: cle, fileId: this.sasSignalementPi.id }
    }
  }
}
</script>

<style>
</style>